export default {
  namespaced: true,

  state: {
    items: [],
    loaded: false
  },

  mutations: {
    retrieve(state) {
      if (!state.items.length) {
        window.Ajax.get('/hires/tariffs')
          .then(response => {
            state.items = response.data;
            state.loaded = true;
          })
          .catch(err => {
            console.log(err);
            state.loaded = true;
          });
      }
    }
  },

  getters: {
    all(state) {
      return state.items;
    },

    loaded(state) {
      return state.loaded;
    },

    gta(state) {
      return state.items.find(
        tariff => tariff.name === 'gta' && tariff.company_id === null
      );
    },

    nonGta(state) {
      return state.items.find(
        tariff => tariff.name === 'non_gta' && tariff.company_id === null
      );
    }
  }
};
